var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { createRef, PureComponent } from "react";
import id from "@irati/utils/id";
import Button from "@irati/ui/src/Button";
import { FormattedMessage } from "@irati/utils/lang";
import { greys } from "@irati/ui/src/global/colors";
import { DropdownOverflow } from "@irati/ui/src/Dropdown";
import Flex from "@irati/ui/src/Flex";
import { Radio } from "./";
import { StyledButton, Wrapper } from "./styled/RadioFilter";
var RadioFilter = /** @class */ (function (_super) {
    __extends(RadioFilter, _super);
    function RadioFilter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dropdown = createRef();
        _this.toggleModal = function () {
            var _a;
            return (_a = _this.dropdown.current) === null || _a === void 0 ? void 0 : _a.toggle();
        };
        _this.shouldFillIcon = function () {
            var _a = _this.props, shouldFillIcon = _a.shouldFillIcon, value = _a.value;
            if (shouldFillIcon) {
                return shouldFillIcon() ? greys.mediumDark : undefined;
            }
            return value ? greys.mediumDark : undefined;
        };
        _this.buildFooter = function () {
            var _a = _this.props, hideFooter = _a.hideFooter, onReset = _a.onReset, onFilter = _a.onFilter, options = _a.options, footer = _a.footer;
            var hasResults = options.length > 0;
            if (hideFooter) {
                return null;
            }
            if (onReset && hasResults) {
                if (footer) {
                    return (React.createElement(Flex, { justifyContent: "space-between" },
                        React.createElement(Button, { onClick: function () {
                                onReset();
                                _this.toggleModal();
                            } },
                            React.createElement(FormattedMessage, { id: "platform.radiofilter.resetbutton.text" })),
                        React.createElement(Button, { primary: true, onClick: function () {
                                onFilter();
                                _this.toggleModal();
                            } },
                            React.createElement(FormattedMessage, { id: "platform.radiofilter.filterButton.text" }))));
                }
                return (React.createElement(StyledButton, { onClick: function () {
                        onReset();
                        _this.toggleModal();
                    } },
                    React.createElement(FormattedMessage, { id: "platform.radiofilter.resetbutton.text" })));
            }
            return null;
        };
        _this.handleChange = function (optionValue, option) {
            var _a = _this.props, toggleModalOnChange = _a.toggleModalOnChange, onChange = _a.onChange;
            onChange(optionValue, option);
            if (toggleModalOnChange) {
                _this.toggleModal();
            }
        };
        return _this;
    }
    RadioFilter.prototype.render = function () {
        var _a = this.props, options = _a.options, value = _a.value, placeholder = _a.placeholder, children = _a.children, overflow = _a.overflow, onToggle = _a.onToggle, icon = _a.icon, rowRenderer = _a.rowRenderer;
        var idNamespace = id("RadioFilter", this.props);
        var hasResults = options.length > 0;
        return (React.createElement(DropdownOverflow, { ref: this.dropdown, id: idNamespace, footer: this.buildFooter(), icon: icon, iconColor: this.shouldFillIcon(), width: 250, onToggle: onToggle },
            !hasResults && !!placeholder && placeholder,
            hasResults && (React.createElement(Wrapper, { overflow: overflow },
                React.createElement(Radio, { rowRenderer: rowRenderer, id: idNamespace, name: name, value: value, onChange: this.handleChange, options: options }),
                children))));
    };
    RadioFilter.defaultProps = {
        onChange: function () { return null; },
        onReset: function () { },
        onFilter: function () { },
        pullRight: false,
        toggleModalOnChange: true,
        footer: false,
        overflow: false,
        hideFooter: false
    };
    return RadioFilter;
}(PureComponent));
export default RadioFilter;
